/**
 * Describes a Country Code object
 */
export class CountryCode {
  locationCountryCode?: string;
}

/**
 * Describes a WFS settings object
 */
export class WFSSettings {
  layerName: string;
  srsName: string = 'EPSG:3857';
  version: string = '2.0.0';
  url: string;
  outputFormat: string = 'gml3';
}

/**
 * Describes a WMS Settings object
 */
export class WMSSettings {
  layerName: string;
  url: string;
}

/**
 * Describes a WMTS background layer settings object
 */
export class WMTSSettings {
  id: number;
  layerName: string;
  name: string;
  type: 'wmts';
  token: string;
  matrixSet: string;
  origin: Array<number>;
  resolutions: Array<number>;
  url: string;
  zoomLevels: Array<number>;
}

/**
 * Describes the ELS Map Services Metadata - not used at the moment. The server can return anything.
 */
export class ELSMetadata {
  lastUpdated: string;
  keywords: string;
  format: string; // user-friendly version of the protocol
  lineage: string;
  coverage: Array<Country>;
  coverageComments: string;
  userDocumentation: Array<ELSUserDocumentation>;
  previewLayerNames: Array<string>;
  previewCentre: Array<number>; // for the basemap
  previewZoomLevel: number; // for the basemap: Format: [1604760.637, 6461619.16]
  previewProjection: string;
  previewOutputFormat: string;
}

/**
 * Describes a Country object
 */
export class Country {
  ISO: string; // ISO alpha-3
  name: string;
}

/**
 * Describes the ELS User Documentation object
 */
export class ELSUserDocumentation {
  url: string;
  title: string;
}

/**
 * Describes a FeatureInfo object
 */
export class FeatureInfo {
  layerName: string;
  properties: Array<Property>;
}

/**
 * Describes a Property Object
 */
export class Property {
  property: string;
  value: string;
}
